import { NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, Input, signal } from '@angular/core';

@Component({
  selector: 'rt-dialog-toolbar',
  styleUrls: ['./dialog-toolbar.component.less'],
  template: `
    <div class="title">
      <ng-content select="[title]"></ng-content>
    </div>
    <div class="actions">
      <ng-content select="[actions]"></ng-content>
    </div>
  `,
  host: {
    '[class.active]': 'active',
    '[class.radius-top]': 'hasRadiusTop()',
  },
  standalone: true,
  imports: [NgTemplateOutlet],
})
export class DialogToolbarComponent {
  @Input() public active: boolean;

  public hasRadiusTop = signal(true);

  constructor(public elementRef: ElementRef) {}
}
